import apiClient from './apiClient';

// ============================================================
// M310 - 庫位批號庫存表(量負) API types and client
// ============================================================

export interface M310ReportRow {
  fm030_01: string;    // 庫位代碼
  fm030_02: string;    // 產品代碼
  fm030_03: string;    // 批號
  fm030_12: string;    // 倉庫代碼
  fm030_13: string | null;  // 入帳日期
  fm030_16: number;    // 庫存量 (< 0)
  fm030_17: number;    // 庫存金額
  fm030_18: number;    // 平均單價
  fm030_51: string;    // 顏色代碼
  fm030_52: string;    // 等級代碼
}

export interface M310ReportResponse {
  items: M310ReportRow[];
  total: number;
}

export interface M310ReportParams {
  startLoc?: string;
  endLoc?: string;
  startProd?: string;
  endProd?: string;
  startBatch?: string;
  endBatch?: string;
  startDate?: string;
  endDate?: string;
}

export const m310Api = {
  async getReport(params: M310ReportParams): Promise<M310ReportResponse> {
    const query: Record<string, string> = {};
    if (params.startLoc)   query['startLoc']   = params.startLoc;
    if (params.endLoc)     query['endLoc']     = params.endLoc;
    if (params.startProd)  query['startProd']  = params.startProd;
    if (params.endProd)    query['endProd']    = params.endProd;
    if (params.startBatch) query['startBatch'] = params.startBatch;
    if (params.endBatch)   query['endBatch']   = params.endBatch;
    if (params.startDate)  query['startDate']  = params.startDate;
    if (params.endDate)    query['endDate']    = params.endDate;

    return (await apiClient.get('/api/m310/report', { params: query })).data;
  },
};
